<article>
  @if (isLoading()) {
    <app-please-wait></app-please-wait>
  }

  @if (!selectedAsset) {
    <table class="table">
      <thead>
        <tr>
          <th></th>
          <th>Asset</th>
          <th>Gateway</th>
          <th>Site</th>
        </tr>
      </thead>
      <tbody>
        @for (asset of list; track asset) {
          <tr (click)="selectedAsset = asset" class="can-click">
            <td><i class="fa fa-square {{ asset.rag }} rag"></i></td>
            <td>{{ asset.title }}</td>
            <td>{{ asset.gatewayTitle }}</td>
            <td>{{ asset.siteTitle }}</td>
          </tr>
        }
      </tbody>
    </table>
  }
</article>

@if (selectedAsset) {
  <main>
    <app-setpoint-detail [assetId]="selectedAsset.id" [rangeId]="2" (onBack)="selectedAsset = null"></app-setpoint-detail>
  </main>
}
